import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';
import { PageHeaderSkeleton } from '@/components/molecules/skeletons';

const RightSidebarSkeleton = (
  <div className="sticky top-20 w-40 h-[600px]">
    <Skeleton className="h-full w-full rounded-xl" />
  </div>
);

export const MessagesPageSkeleton = memo(() => {
  return (
    <PageContainer rightSidebar={RightSidebarSkeleton}>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <div className="bg-card border border-border rounded-xl shadow-none p-6 space-y-4">
          <Skeleton className="h-6 w-40 rounded-md" />
          <Skeleton className="h-32 w-full rounded-lg" />
        </div>
      </div>
    </PageContainer>
  );
});

MessagesPageSkeleton.displayName = 'MessagesPageSkeleton';
